// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TaxonomyCategoryFilter_wrap__5OVdj","chip":"TaxonomyCategoryFilter_chip__fhYIa","chipActive":"TaxonomyCategoryFilter_chipActive__pgpYP"};